// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2j6uh","content":"GlobalSearch_content__168i4"};